import { DataLayer } from './data-layer.model';

/* eslint-disable */

export enum ItemCategory {
  Policy = 'Policy',
  Coverage = 'Important Coverages',
  Additional = 'Additional Coverages'
}

export interface EcommerceModel {
  items: EcommerceItem[];
  tax?: number;
  transaction_id?: number;
  value?: number;
  currency?: string;
}

export interface EcommerceItem {
  item_id: number;
  item_name: string;
  price?: number;
  currency: string;
  item_category: ItemCategory;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  affiliation?: string;
  destination?: string;
  continent?: ContinentsEnum;
  policy_type?: string;
  excess_amount?: number;
  cover_limit?: number;
  coupon?: string;
  discount?: number;
  policy_length?: number;
  policy_composition?: string[] | string;
  days_before_departure?: number;
  quantity?: number;
  month_of_travel?: string;
}

export enum ContinentsEnum {
  'Europe' = 1,
  'South Africa' = 2,
  'South America' = 3,
  'Asia' = 5,
  'Middle East' = 6,
  'Oceania' = 7,
  'North America' = 8
}

export enum EcommerceEvents {
  checkout = 'begin_checkout',
  cart = 'view_cart',
  add = 'add_to_cart',
  remove = 'remove_from_cart',
  shipping = 'add_shipping_info',
  payment = 'add_payment_info',
  purchase = 'purchase',
  transaction = 'transaction'
}

export enum TravelerAgeType {
  Adult = 1,
  Children = 2,
  Apotropos = 3
}

export interface EcommerceModelGA4 {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  transaction_id: number | undefined;
  currency: string;
  value: number;
  coupon?: number | string;
  tax?: number;
  items: EcommerceItem[];
}

export interface ActionField {
  id?: number; // Quote ID
  affiliation?: string;
  revenue?: number; // Total policy price
  step?: number;
}

export interface Product {
  name?: string;
  brand?: string;
  category?: string;
  price?: number; // totalPrice
  quantity?: number;
}

export type EcommerceDataLayer = Partial<DataLayer>;
